/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React, { useEffect, useState } from "react";
import {
	Select,
	Tooltip
} from "antd";
import { LockedGroupLabel, NO_PERMISSION_LABEL, NO_PERMISSION_TOOLTIP } from "@components/PermissionedComponents/lockedStreamGroups";

const { Option, OptGroup } = Select;

/** @param {{ width?: number | string } & Record<string, any>} props */
export const OptionGroupSelect = ({ placeholder, options, width=300, selectedOptionVal, sideId, handleOptionGroupChange, mode = "multiple", disabled })  => {

  const [optionGroupValue, setOptionGroupValue] = useState([]);
  const maxTagCount = (placeholder === 'Full Team' ? 'responsive' : undefined)
  useEffect(() => {
      setOptionGroupValue(selectedOptionVal);
  }, [selectedOptionVal])

  return (
    <>
      <Select
        placeholder={placeholder}
        mode={mode}
        disabled={disabled}
        className="option-group-select"
        style={{
          width: width,
        }}
        onChange={handleOptionGroupChange}
        value={optionGroupValue}
        maxTagCount={maxTagCount}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option?.label?.props?.children?.toLowerCase()?.includes(input.toLowerCase()) || false;
        }
        }
      >
        {options.map((group, groupIndex) => (
          <OptGroup
            key={groupIndex}
            label={
              group.disabled ? (
                <Tooltip title={NO_PERMISSION_TOOLTIP} placement="right">
                  <span><LockedGroupLabel label={group.label} /></span>
                </Tooltip>
              ) : (
                group.label
              )
            }
          >
            {group.disabled ? (
              // The metric names themselves are withheld — a locked group shows one
              // unclickable row instead of its list, so the stream is visible as
              // something to request access to without exposing its contents.
              <Option
                key={`${sideId}-${groupIndex}-no-permission`}
                value={`__no-permission-${groupIndex}`}
                label={NO_PERMISSION_LABEL}
                disabled
              >
                {NO_PERMISSION_LABEL}
              </Option>
            ) : (
              group.options?.map((option, optionIndex) => (
                <Option 
                  key={`${sideId}-${option.key}-${groupIndex}-${optionIndex}`} 
                  value={option.value} 
                  label={option.label}
                  disabled={option.disabled || false}
                >
                  {option.label}
                </Option>
              ))
            )}
          </OptGroup>
        ))}
      </Select>
    </>
  );
}
